var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.62 1.20999C14.4109 1.04445 14.1444 0.969289 13.8796 1.00121C13.6148 1.03314 13.3738 1.1695 13.21 1.37999L6.21001 10.38L2.78001 6.19999C2.56095 5.90839 2.20051 5.75918 1.83944 5.81062C1.47837 5.86206 1.17395 6.10599 1.04503 6.44716C0.916123 6.78834 0.983176 7.17263 1.22001 7.44999L5.39001 12.63C5.58064 12.865 5.86742 13.001 6.17001 13C6.49172 13.0144 6.80067 12.8729 7.00001 12.62L14.83 2.61999C14.9913 2.40592 15.0598 2.13608 15.0204 1.871C14.9809 1.60592 14.8366 1.36778 14.62 1.20999Z",
    fill: "#0ABAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.62 1.20999C19.4109 1.04445 19.1444 0.969289 18.8796 1.00121C18.6148 1.03314 18.3738 1.1695 18.21 1.37999L11.21 10.38L10.6 9.62999L9.34001 11.25L10.44 12.62C10.6306 12.855 10.9174 12.991 11.22 12.99C11.5243 12.9886 11.8114 12.8487 12 12.61L19.83 2.60999C19.9881 2.39659 20.0548 2.12907 20.0154 1.86643C19.976 1.6038 19.8337 1.36762 19.62 1.20999Z",
    fill: "#0ABAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71001 8.05999L8.00001 6.43999L7.80001 6.19999C7.64048 5.97897 7.39763 5.83265 7.12768 5.79489C6.85773 5.75714 6.58406 5.83122 6.37001 5.99999C6.16253 6.16666 6.03005 6.40917 6.00189 6.67381C5.97374 6.93845 6.05224 7.2034 6.22001 7.40999L6.71001 8.05999Z",
    fill: "#0ABAB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.5ea516eef3cea0b8a92261a7f4818a83.svg";
export { ForwardRef as ReactComponent };